/** 文本格式化（与 iOS 家长端 Fmt 一致） */

/** "刚刚" / "3 分钟前" / "2 小时前" / "5 天前"；没有时间返回 "从未同步" */
export function ago(ms: number | null | undefined, now = Date.now()): string {
  if (ms == null) return "从未同步";
  const sec = Math.max(0, Math.floor((now - ms) / 1000));
  if (sec < 60) return "刚刚";
  if (sec < 3600) return `${Math.floor(sec / 60)} 分钟前`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} 小时前`;
  return `${Math.floor(sec / 86400)} 天前`;
}

/** 提醒偏移："准时" / "提前 10 分钟" / "提前 1 小时" / "延后 5 分钟" */
export function offsetText(m: number): string {
  if (m === 0) return "准时";
  if (m < 0) {
    const a = -m;
    return a >= 60 && a % 60 === 0 ? `提前 ${a / 60} 小时` : `提前 ${a} 分钟`;
  }
  return `延后 ${m} 分钟`;
}

/** 时长："45 分钟" / "1 小时" / "1 小时 30 分钟" / "2 天" */
export function durationText(min: number): string {
  if (min >= 1440 && min % 1440 === 0) return `${min / 1440} 天`;
  if (min < 60) return `${min} 分钟`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m ? `${h} 小时 ${m} 分钟` : `${h} 小时`;
}

/** 积分变化："+10" / "-30" */
export function signed(n: number): string {
  return n > 0 ? `+${n}` : String(n);
}

/** 文件大小："1.2 MB" */
export function fileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
